import { defineStore } from "pinia";

export const useCatalogListsStore = defineStore("CatalogListsStore", {
  state: () => ({
    data: null,
    loading: false,
  }),
  actions: {
    async fetchLists(query) {
      this.loading = true;
      try {
        const response = await this.$axios.get(`/api/v1/catalog/lists?q[name_cont]=${query}`);
        this.data = response.data;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      this.loading = false;
    },
    async fetchList(id) {
      try {
        const response = await this.$axios.get(`api/v1/catalog/lists/${id}`);
        return response;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  }
});
